var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("search-picker", {
    attrs: {
      "input-id": _vm.inputId,
      current: _vm.current,
      placeholder: _vm.placeholder,
      "full-width": _vm.fullWidth,
      "with-icon": _vm.withIcon,
      "with-popper": _vm.withPopper,
      "get-data": _vm.getTags,
      "can-add": _vm.canAdd,
    },
    on: { selected: _vm.selected },
    scopedSlots: _vm._u([
      {
        key: "list-item-content",
        fn: function ({ option }) {
          return [
            option.ancestors && option.ancestors.length
              ? _c(
                  "div",
                  { staticClass: "search-picker__subtext" },
                  _vm._l(option.ancestors, function (ancestor, ancestorIndex) {
                    return _c(
                      "span",
                      { key: `name-${option.id}-${ancestor.id}` },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(ancestorIndex > 0 ? " > " : "") +
                            _vm._s(ancestor.name) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }